import { Component } from '@angular/core';
import { Validators } from "@angular/forms";

// EZ
import { EzFormComponent } from "../../../ez-form/ez-form.component";
import { DocMeta } from "../../../../decorators";
import { InputConfig } from "../../../../types";

@DocMeta({
  hide: true,
  showcaseTitle: "Validation",
  showcaseDesc: `
  ## Validation Sample

  This sample demonstrates **form validation** using the \`EzFormComponent\` and Angular's built-in \`Validators\`.

  - Each input field in the form is configured with validation rules and custom error messages.
  - Validation is handled automatically by Angular's reactive forms.
  - Error messages are displayed when validation fails for a field.

  ### How Validation Works

  - The \`validation\` property in each \`InputConfig\` specifies an array of Angular validator functions (e.g., \`Validators.required\`, \`Validators.email\`, \`Validators.min\`).
  - The \`validationMessages\` property maps validator keys to custom error messages for user-friendly feedback.
  - The Ez form component automatically applies these rules and displays errors as needed.

  `
})
@Component({
    selector: 'ui-form-validation-sample, ez-form-validation-sample',
    imports: [EzFormComponent],
    templateUrl: './validation-sample.component.html',
    styleUrls: ['./validation-sample.component.scss']
})
export class EzFormValidationSampleComponent {

  validationsFormConfig: InputConfig[] = [
    { name: 'firstName', type: 'text', label: 'First Name', row: 1, width: '2x', validation:  [Validators.required ], validationMessages: { required: 'First Name is required' } },
    { name: 'lastName', type: 'text', label: 'Last Name', row: 2, width: '2x', validation:  [Validators.required], validationMessages: { required: 'Last Name is required' } },
    { name: 'email', type: 'text', label: 'Email', row: 3, width: '1x', validation:  [Validators.required, Validators.email], validationMessages: { required: 'Email is required', email: 'Email must be a valid email address' } },
    { name: 'age', type: 'number', label: 'Age', row: 3, width: '1x', validation:  [Validators.min(18), Validators.max(99)], validationMessages: { min: 'Age must be at least 18', max: 'Age must be less than 99' } },
    { name: 'password', type: 'password', label: 'Password', row: 4, width: '2x', validation:  [Validators.required, Validators.minLength(6)], validationMessages: { required: 'Password is required', minlength: 'Password must be at least 6 characters' } },
    { name: 'confirmPassword', type: 'password', label: 'Confirm Password', row: 5, width: '2x', validation:  [Validators.required], validationMessages: { required: 'Confirm Password is required' } }
  ];
}
